import { useState } from 'react';
import { CalendarDays } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { DeadlineCalendarModal } from './DeadlineCalendarModal';
import { useDeadlineNotifications } from '@/hooks/useDeadlineNotifications';

export function DeadlineTriggerButton() {
  const [isOpen, setIsOpen] = useState(false);
  const { urgentCount } = useDeadlineNotifications();

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="ghost"
            size="sm"
            className="w-full justify-start gap-2 relative"
            onClick={() => setIsOpen(true)}
            data-deadline-trigger
          >
            <CalendarDays className="h-4 w-4" />
            <span>Plazos</span>
            {urgentCount > 0 && (
              <Badge 
                variant="destructive" 
                className="ml-auto h-5 min-w-5 flex items-center justify-center text-xs px-1"
              >
                {urgentCount > 9 ? '9+' : urgentCount}
              </Badge>
            )}
          </Button>
        </TooltipTrigger>
        <TooltipContent side="right">
          <p>Calendario de plazos administrativos</p>
          {urgentCount > 0 && (
            <p className="text-destructive text-xs">
              {urgentCount} plazo{urgentCount > 1 ? 's' : ''} urgente{urgentCount > 1 ? 's' : ''}
            </p>
          )}
        </TooltipContent>
      </Tooltip>

      <DeadlineCalendarModal open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
}
